'use client';

import { track } from '@smartproxy/sp-tracker-js';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { getCookie } from '@/utils/cookies';

import { COOKIE_NAMES } from './constants';

const trackImpression = (flagId: string, variant: string) => {
  track('experiment_impression', {
    exp_experiment_id: flagId,
    variant_id: `${variant}`,
    exp_variant_id: variant === 'control' ? '0' : '1',
  });
};

const trackGlobalExperimentsImpression =
  (
    selector: string,
    flagId: string,
    variant: string,
    dataExpType: 'data-exp-id' | 'data-exp-kind'
  ) =>
  (event: Event) => {
    const target = event.target as HTMLElement;

    // Check if target or any of its parents contain the prop
    let currentElement: HTMLElement | null = target;
    // console.log('[experimentation] Clicked element', target);

    while (currentElement) {
      if (currentElement.getAttribute(dataExpType) === selector) {
        console.log('[110]', dataExpType, selector);

        trackImpression(flagId, variant);
        return;
      }
      currentElement = currentElement.parentElement;
    }
  };

/**
 * TODO: remove once experimenting with fast checkout is complete
 */
const _TEMP__hardcodedExperimentPaths = [
  '/proxies/residential-proxies',
  '/proxies/residential-proxies-variant-1',
  '/proxies/residential-proxies/pricing',
  '/proxies/residential-proxies/pricing-variant-1',
];

export function ExperimentTracker() {
  const pathname = usePathname();

  const globalClickHandler = useRef<((e: any) => any) | undefined>(undefined);

  useEffect(() => {
    console.log('[100]', pathname);
    if (!_TEMP__hardcodedExperimentPaths.includes(pathname)) {
      console.log('[101]');
      return;
    }

    const intId = setInterval(() => {
      console.log('[102]');
      // First check the cookie for experiment data
      const cookieState: any = getCookie(COOKIE_NAMES.BOOTSTRAP_EXPERIMENTS);

      if (!cookieState) return;
      console.log('[103]');
      clearInterval(intId);
      const { experimentPaths, featureFlags, featureFlagPayloads } =
        cookieState;

      const flagId = experimentPaths?.[pathname];
      const variant = featureFlags?.[flagId];
      const flagPayload = featureFlagPayloads?.[flagId];

      const selector = flagPayload?.track_impression_on_element_click;

      globalClickHandler.current = trackGlobalExperimentsImpression(
        selector,
        flagId,
        variant,
        flagPayload?.data_exp_type || 'data-exp-id'
      );

      document.body.addEventListener('click', globalClickHandler.current);

      // TODO: might be worth considering if we want to verbosely set track_impression_on_visit and potentially other configs
      const shouldTrackOnVisit =
        variant && flagId && !flagPayload?.track_impression_on_element_click;

      if (shouldTrackOnVisit) {
        // track on visit instead -> shoot the event immediately
        // console.log('[experimentation] impression tracked for visit', selector);
        trackImpression(flagId, variant);
        // TODO: decide if we want to remove the event listener after tracking on visit, since we can potentially track on click as well
        document.body.removeEventListener('click', globalClickHandler.current);
      }
    }, 200);

    return () => {
      globalClickHandler.current &&
        document.body.removeEventListener('click', globalClickHandler.current);

      console.log('[105]');
      clearInterval(intId);
    };
  }, [pathname]);

  return null;
}
